import { z } from "zod/v4-mini";

// Location data schema
const LocationDataSchema = z.object({
  external_id: z.string(),
  name: z.optional(z.string()),
  full_address: z.optional(z.string()),
  continent_code: z.optional(z.string()),
  continent_name: z.optional(z.string()),
  country_code: z.string(),
  country_name: z.string(),
  region_code: z.optional(z.string()),
  region_name: z.optional(z.string()),
  city: z.optional(z.string()),
  zip: z.optional(z.string()),
  latitude: z.number(),
  longitude: z.number(),
  types: z.optional(z.array(z.string())),
  raw: z.optional(z.string()),
});

// Track event payload schema
export const TrackEventPayloadSchema = z.object({
  action: z.string().check(z.minLength(1)),
  description: z.optional(z.string()),
  externalExperienceId: z.optional(z.string()),
  externalObjectId: z.optional(z.string()),
  location: z.optional(LocationDataSchema),
  metadata: z.optional(z.object()),
});

export const TrackEventResponseSuccessSchema = z.object({
  userActionId: z.nullable(z.string()),
  didReward: z.boolean(),
  points: z.number(),
  userId: z.string(),
  notificationMessage: z.nullable(z.string()),
  notificationTitle: z.nullable(z.string()),
});

export const TrackEventResponseErrorSchema = z.object({
  success: z.literal(false),
  error: z.string(),
  message: z.string(),
});

// API response schema
export const TrackEventResponseSchema = z.xor([
  TrackEventResponseSuccessSchema,
  TrackEventResponseErrorSchema,
]);
